 
 
 
 
 
 
define(['leaflet'], function(L) {
    'use strict';
    return function(position) {
        var div = L.DomUtil.create('div', 'tomtom-point-content__coordinates');

        div.innerHTML = position.lat + ', ' + position.lng;
        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/coordinatesContent.js